export default {
  activateText: 'Refresh immediately after release',
  deactivateText: 'Pull down to refresh',
  finishText: 'Finish refresh',
};
